import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getBusinessOperation = async () => {
  const { data } = await axios.get(
    `${api_base_url}/BusinessOperation/BusinessOperation`
  );
  return data;
};
// Insert New BusinessOperation
export const addBusinessOperation = async (newBusinessOperation) => {
  const { data } = await axios.post(
    `${api_base_url}/BusinessOperation/BusinessOperation`,
    {
      ...newBusinessOperation[0],
    }
  );
  return data;
};
// Update BusinessOperation

export const updateBusinessOperation = async (updatedBusinessOperation) => {
  const { data } = await axios.put(
    `${api_base_url}/BusinessOperation/BusinessOperation${updatedBusinessOperation[0].businessOperationId}`,
    ...updatedBusinessOperation
  );
  return data;
};

export const deleteBusinessOperation = async (ids) => {
  await axios.delete(`${api_base_url}/BusinessOperation/BusinessOperation`, {
    data: ids,
  });
};
